import { HR_CLERK } from "../../utils/Roles";
import { IMPLEMENTATION, INACTIVE, TERMINATED } from "../dashboard/clients/enums/clientStatusTypes";

export const isAssociatedClientUserReadOnly = (client, roleId=null) => {
    let clientStatus = [TERMINATED.value, INACTIVE.value];

    if (roleId == HR_CLERK.roleId){
        clientStatus.push(IMPLEMENTATION.value);
    }

    return client && clientStatus.includes(client.clientStatusType);
};


// WEBPACK FOOTER //
// ./src/components/common/clientHelper.js